import { Grid, Typography, styled } from "@mui/material";
import { useEffect } from "react";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import ChangeLogTable from "./component/change-log-table";
import { changeLogInitAction } from "./redux/change-log.actions";

export const ChangeLog = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(changeLogInitAction());
    }, [dispatch]);

    return (
        <PageTemplate pageTitle="Change Log" className={className}>
            <Grid container>
                <Typography className="title" component="h6">
                    Change Log
                </Typography>
            </Grid>
            <ChangeLogTable />
        </PageTemplate>
    );
};
export default styled(ChangeLog)(({ theme }: IWithThemeProps) => ({
    marginBottom: theme?.spacing(1),
    ".title": {
        fontSize: 20,
        marginBottom: theme?.spacing(9),
        fontWeight: 600,
        textTransform: "uppercase",
    },
}));
